var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var RowNumber = /** @class */ (function (_super) {
    __extends(RowNumber, _super);
    function RowNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowNumber.prototype.render = function () {
        return this.props.visible ? (React.createElement("div", { className: "seat-picker__row__number", style: this.props.style }, this.props.rowNumber)) : null;
    };
    return RowNumber;
}(Component));
export default RowNumber;



//////////////////
// WEBPACK FOOTER
// ./src/components/Seatmap/SeatPicker/RowNumber.tsx
// module id = 1271
// module chunks = 0